module.exports = __webpack_public_path__ + "static/media/ai_chat_assistant_icon.d2127081.svg";